import { colors } from '@shared/interfaces/paleta-cores';

export const optionsChartPluviometriaObservada: Highcharts.Options = {
	chart: {
		type: 'column',
		backgroundColor: 'transparent',
	},
	colors: colors,
	title: {
		text: 'Pluviometria (mm)',
		align: 'center',
	},
	tooltip: {
		valueSuffix: ' mm',
		valueDecimals: 1,
	},
	yAxis: [
		{
			title: {
				text: 'Precipitação (mm)',
			},
		},
	],
	navigator: {
		enabled: false,
	},
	exporting: {
		enabled: true,
		buttons: {
			contextButton: {
				menuItems: [
					'viewFullscreen',
					'separator',
					'downloadPNG',
					'downloadJPEG',
				],
			},
		},
	},
	rangeSelector: {
		enabled: false,
	},
	credits: {
		enabled: false,
	},
	xAxis: [{ categories: [] }],
	series: [],
};
